import React from 'react'
import CloseButton from 'redesign/components/atoms/Buttons/CloseButton'
import { ButtonContainer, Container } from './styles'
import type { DrawerHeaderEndContentProps } from './types'

const DrawerHeaderEndContent: React.FC<DrawerHeaderEndContentProps> = ({
  closeIconOnClick,
  children,
  hideCloseButton = false,
}) => (
  <Container>
    {children}
    {hideCloseButton ? null : (
      <ButtonContainer>
        <CloseButton onClick={closeIconOnClick} />
      </ButtonContainer>
    )}
  </Container>
)

export default DrawerHeaderEndContent
